var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-toolbar-search flex flex-none justify-center items-center h-14 lg:h-20 py-3 bg-skin-fill-inverted text-skin-inverted"},[_c('form-find-product-search',{staticClass:"w-10/12 sm:w-8/12 md:w-6/12 max-w-[852px] h-full"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }